<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h3 class="text-center">Thème «{{ currentTheme.name }}» - Liste des réalisateurs</h3>
      </div>
    </div>
  <hr>
  <div class="row">
    <div class="col-md-12">
      <router-link tag="button" class="btn btn-info btn-sm" type="button" :to="{ name: 'RealLink', params: { id: currentTheme.id } }">Associer un réalisateur</router-link>
    </div>
  </div>
  <hr>
  <div class="row">
    <div class="col-md-12">
      <table class="table table-hover">
          <thead>
              <tr>
                  <th>Prénom</th>
                  <th>Nom</th>
                  <th>Email</th>
              </tr>
          </thead>
          <tbody v-if="reals.length">
              <tr v-for="real in reals" :key="real.id">
                  <td v-html="real.firstname"></td>
                  <td v-html="real.lastname"></td>
                  <td v-html="real.email"></td>
                  <td>
                      <button class="btn btn-info btn-sm" type="button" @click="toggleUntoggleDelete(real)">Supprimer</button>
                  </td>
              </tr>
          </tbody>
          <tbody v-else>
          <tr>
              <td>
                  Aucun realisateur.
              </td>
          </tr>
          </tbody>
      </table>
      <div class="pager"></div>
    </div>
  </div>
    <modal effect="fade" :title="deleteModalTitle" :value="showDeleteModal" cancel-text="Annuler" ok-text="Supprimer" @ok="unlinkReal()" @cancel="toggleUntoggleDelete()">
      <div v-html="deleteModalText">
      </div>
  </modal>
</div>
</template>


<script>
    import { alert as VAlert, input as BsInput, modal as Modal, typeahead as Typeahead }  from 'vue-strap'
    import ImportTextFiles from 'components/ImportTextFiles'
    import VoiceSelection from 'components/VoiceSelection';

    export default {
        components: {
            Modal,
            BsInput,
            ImportTextFiles,
            Typeahead,
            VAlert,
            VoiceSelection
        },
        computed: {
            currentTheme: function() {
                return this.$store.state.admin.currentTheme;
            },
            reals: function() {
                return this.currentTheme.reals;
            },
            deleteModalTitle: function()  {
                return "Suppression du réalisateur"; // \"" + this.real.lastname + "\"";
            },
            deleteModalText: function()  {
                return "Confirmez-vous la suppression du réalisateur"; // \"" + this.real.lastname + "\" ?";
            },
        },
        methods: {
            toggleUntoggleDelete(real)  {
                if (real)  {
                    this.modalReal= real;
                }
                this.showDeleteModal = !this.showDeleteModal;
            },
            unlinkReal()  {
                let successCallback = () => {
                    this.toggleUntoggleDelete();
                    this.$store.dispatch('getTheme', {themeId: this.currentTheme.id, callbacks: {
                        success: (data) => {
                            this.$store.commit("CURRENT_THEME_UPDATED", data);
                            this.$store.commit('ALERT_DATA_UPDATED', {
                                    text: 'Le réalisateur a été supprimé avec succès.',
                                    type: 'success'
                            });
                            this.$store.commit("THEME_LIST_UPDATED", data);
                        }
                    }});
                };
                this.$store.dispatch('unlinkReal', { userId: this.modalReal.id,
                                                     themeId: this.currentTheme.id,
                                                     callbacks: { success: successCallback,
                                                                     fail: this.toggleUntoggleDelete,
                                                                     error: this.toggleUntoggleDelete }
                                                    });
            },
        },
        data: function()  {
            return {
                showDeleteModal: false,
                modalReal: {
                    id: 0,
                    firstname: "",
                    lastname: "",
                    email: "",
                },
            };
        },
        beforeCreate()  {
            this.$emit('navbarUpdate', {
                text: 'Retour aux thèmes',
                pathData: {
                    name: "ThemeList"
                }
            });
        }
    };
</script>

<style>


</style>
